import { MutationResponse } from "../../domain/models/http/MutationsRequest";
import { MissingCardPaymentMutableAttributes } from "../../domain/models/MissingCardPayment";
import QueryService from "../QueryService";

class MissingCardPaymentMutationService extends QueryService<never> {
  public constructor(baseURL: string, pathname: string) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }

  public async update(
    key: string,
    attributes: MissingCardPaymentMutableAttributes,
  ): Promise<MutationResponse> {
    const response = await this.api.post(`${this.pathname}/mutate`, {
      mutate: [{ operation: "update", key, attributes }],
    });

    return response.data;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const missingCardPaymentMutationService = new MissingCardPaymentMutationService(
  BASE_URL,
  "missing_card_payments",
);

export { missingCardPaymentMutationService };
